<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Nueva tarea" />

        <tareanueva />

    </div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import tareanueva from "@/components/TaskNew"


export default {

    name: 'tarea-nueva',
    components: {
        toolbar,
        tareanueva,
    },
    data() {
        return {
            toolbar: {
                return: '0'
            },
        }
    },
    created() {
        auth.getUserLogged()
    }

};


</script>
